import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import themeReducer from './themeSlice';
import targetReducer from './targetSlice';
import selectedOrganizationReducer from './selectedOrganizationSlice';
import publicUserMenuReducer from './publicUserMenuSlice';
import selectedServiceProviderReducer from './selectedServiceProviderSlice';
import selectedOrganizationForUserReducer from './selectedOrganizationForUserSlice';
import selectedServiceProviderForUserReducer from './selectedServiceProviderForUserSlice';
import serviceProviderReducer from './serviceProviderSlice';
import organizationTaskReducer from './organizationTaskSlice';
import organizationUsersReducer from './organizationUserSlice';
import loyaltyPointsReducer from './loyaltyPointSlice';
import serviceProviderAvailabilityReducer from './serviceProviderAvailabilitySlice';
import serviceProviderAvailabilitiesDialogReducer from './serviceProviderAvailabilitiesDialogSlice';
import clientsDialogReducer from './clientsDialogSlice';
import infoReducer from './infoSlice';
import organizationTasksDialogReducer from './organizationTasksDialogSlice';
import loyaltyPointsDialogReducer from './loyaltyPointsDialogSlice';
import gettingProDialogReducer from './gettingProDialogSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    themeState: themeReducer,
    target: targetReducer,
    selectedOrganization: selectedOrganizationReducer,
    publicUserMenu: publicUserMenuReducer,
    selectedServiceProvider: selectedServiceProviderReducer,
    selectedOrganizationForUser: selectedOrganizationForUserReducer,
    selectedServiceProviderForUser: selectedServiceProviderForUserReducer,
    serviceProviders: serviceProviderReducer,
    organizationTasks: organizationTaskReducer,
    organizationUsers: organizationUsersReducer,
    loyaltyPoints: loyaltyPointsReducer,
    serviceProviderAvailabilities: serviceProviderAvailabilityReducer,
    serviceProviderAvailabilitiesDialog: serviceProviderAvailabilitiesDialogReducer,
    clientsDialog: clientsDialogReducer,
    info: infoReducer,
    organizationTasksDialog: organizationTasksDialogReducer,
    loyaltyPointsDialog: loyaltyPointsDialogReducer,
    gettingProDialog: gettingProDialogReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;